import { Component, OnInit } from '@angular/core';
import {convertToSnakeCase, getApiFormattedDate} from "../../ccass/utils/util-functions";
import {TOP_NAV_TITLES, SIDE_NAV_TITLES} from "../common/it-constants";


@Component({
  selector: 'app-eod-distributor',
  templateUrl: './eod-distributor.component.html',
  styleUrls: ['./eod-distributor.component.scss']
})
export class EodDistributorComponent implements OnInit {

  loading = true;
  startDate: Date;
  endDate: Date;
  selectedItem = localStorage.getItem('selectedItem') ?
    localStorage.getItem('selectedItem') : convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  fundDayEndReportKey = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);
  newSecurityKey = convertToSnakeCase(SIDE_NAV_TITLES.newSecurity);

  displayTopbar = true;
  firstPageTitle: string = TOP_NAV_TITLES.it
  pageTitle: string = TOP_NAV_TITLES.fde_deo_distributor;
  lastPageTitle: string = TOP_NAV_TITLES.lastPageTitle;

  constructor() { }

  ngOnInit(): void {
    this.loading = false;
  }

  // Date functions
  updateStartDate(key) {
    this.startDate = key;
    this.getFilteredClientList();
  }
  updateEndDate(key) {
    this.endDate = key;
    this.getFilteredClientList();
  }

  getFilteredClientList() {
    if (this.startDate && this.endDate) {
      const query = {};
      query['endDate'] = getApiFormattedDate(this.endDate);
      query['startDate'] = getApiFormattedDate(this.startDate);
    }
  }

  OnExportClick() {
    alert(123);
  }

  // Event functions
  selectedMenu(key) {
    this.selectedItem = key;
    localStorage.setItem('selectedItem', key);
  }
}
